import axios from "axios";
import { silentHTTPCaller, toastWrapper } from "../utils/toastWrapper";
import { appDispatch } from "../app/store";
import { setProduct, setShowVerificationPending, setWorkflows } from "../app/slice/authSlice";
import { getAppId, getIDBaseURL } from "../utils/getBaseURL";

const url = getIDBaseURL();
const headers = {
    ApplicationId: getAppId() || ''
}

export const getWorkFlows = () => {
  const call = axios.get(`${url}Workflow/all`, { headers })
  silentHTTPCaller(
    call,
    'Loading your workflow...',
    (resp) => {
      appDispatch(setWorkflows(resp.data.data));
      return resp.data.message || 'Workflows loaded!';
    },
    'Error loading work flow',
    (err) => {
      // @ts-ignore
      return err?.response?.data?.message || 'Error loading workflow';
    },
    () => {
      // handleError && handleError();
    })
}

export const createWorkflow = (data: Record<string, any>, handleDone) => {
  const call = axios.post(`${url}Workflow/create-workflow`, data, { headers })
  toastWrapper(call, 'Creating a new workflow...', (resp) => {
    handleDone();
    return resp.data.message || 'Workflow created successfully!';
  }, 'Error creating workflow!');
}

export const updateWorkflow = (data, handleDone) => {
  const call = axios.put(`${url}Workflow/update-workflow`, data, { headers })
  toastWrapper(call, 'Updating workflow...', (resp) => {
    handleDone(resp.data);
    return resp.data.message || 'Workflow updated';
  }, 'Error updating workflow!');
}

export const deleteWorkflow = (id: string, handleDone) => {
  const call = axios.delete(`${url}Workflow/delete-workflow/${id}`, { headers })
  toastWrapper(call, 'Deleting working flow...', (resp) => {
    handleDone(resp.data);
    return resp.data.message || 'Workflow deleted';
  }, 'Error deleting workflow!');
}

export const getWorkflowAudits = (handleDone) => {
    const call = axios.get(`${url}workflow/audits`, { headers })
    toastWrapper(call, 'Loading workflow Audit...', (resp) => {
        handleDone(resp.data);
        return resp.data.message || 'Audits loaded successfully';
    }, 'Error loading Audits!');
}

export const removeUserFromWorkflow = (workflowId: string, userId: string, handleDone) => {
  const call = axios.delete(`${url}workflow/${workflowId}/remove/${userId}`, { headers })
    toastWrapper(call, 'Removing User from Workflow...', (resp) => {
        handleDone();
        return resp.data.message || 'User removed from Workflow.';
    }, 'Error removing User from Workflow!');
}
